import gql from 'graphql-tag';

export const SUBMIT_CAMPAIGN = gql`
    mutation submitCampaign($input: SubmitCampaignInput!) {
        submitCampaign(input: $input) {
            orderNumber
        }
    }
`;
